module.exports = __webpack_public_path__ + "img/mx_03.93558d29.jpg";